<div class="container">
    <ng-container *ngFor="let gauge of gauges">
        <div class="gauge-card">
            <div i18n class="gauge-label">{{ gauge.label }}</div>

            <div class="gauge-bar-horizontal">
                <div class="gauge-fill-horizontal" [ngClass]="'status-' + gauge.zone.status" [style.width.%]="gauge.zone.current"></div>

                <div class="marker-limit min" [style.left.%]="gauge.zone.min"></div>
                <div class="marker-limit max" [style.left.%]="gauge.zone.max"></div>
            </div>

            <div class="marker-value-readout" [ngClass]="gauge.zone.status">
                <span i18n class="value">{{ gauge.speed.current }} RPM</span>
                <div class="icono"></div>
            </div>
        </div>
    </ng-container>
</div>
